/**
 * Generated by orval 🍺
 * Do not edit manually.
 * RepeatMD.AdminApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  DisplayAgelessHostConfiguration,
  DisplayAgelessWebsiteEmbedSettingsResponse,
  DisplayAiAutoReplySettingsResponse,
  DisplayGeneratedAgelessMarketingSetupTokenResponse,
  DisplayGeneratedAgelessWebsiteEmbedTokenResponse,
  DisplayValidatedAgelessWebsiteEmbedTokenResponse,
  GenerateAgelessMarketingSetupTokenRequest,
  GenerateAgelessWebsiteEmbedTokenRequest,
  GetAiAutoReplySettingsParams,
  GetWebsiteEmbedSettingsParams,
  ProblemDetails,
  SendAgelessWebsiteEmbedInstructionsRequest,
  SetAllowedOriginsForAgelessWebsiteEmbedRequest,
  SetBeautyScoreDisplayNameRequest,
  ValidateWebsiteEmbedTokenHeaders,
  ValidateWebsiteEmbedTokenParams
} from '../model';

import { customAxios } from '../../custom-axios';
import type { ErrorType } from '../../custom-axios';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Set the beauty score display name for an Ageless platform.
 */
export const setBeautyScoreDisplayName = (
    platformId: string,
    setBeautyScoreDisplayNameRequest: SetBeautyScoreDisplayNameRequest,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/ageless/platforms/features/${platformId}/beauty-score-display-name`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setBeautyScoreDisplayNameRequest, signal
    },
      );
    }




export const getSetBeautyScoreDisplayNameMutationKey = () => ['setBeautyScoreDisplayName'] as const;

export const getSetBeautyScoreDisplayNameMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setBeautyScoreDisplayName>>, TError,SetBeautyScoreDisplayNameMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setBeautyScoreDisplayName>>, TError,SetBeautyScoreDisplayNameMutationVariables, TContext> => {

const mutationKey = getSetBeautyScoreDisplayNameMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setBeautyScoreDisplayName>>, SetBeautyScoreDisplayNameMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  setBeautyScoreDisplayName(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetBeautyScoreDisplayNameMutationResult = NonNullable<Awaited<ReturnType<typeof setBeautyScoreDisplayName>>>
    export type SetBeautyScoreDisplayNameMutationBody = SetBeautyScoreDisplayNameRequest
    export type SetBeautyScoreDisplayNameMutationError = ErrorType<ProblemDetails>
    export type SetBeautyScoreDisplayNameMutationVariables = {platformId: string;data: SetBeautyScoreDisplayNameRequest}

    /**
 * @summary Set the beauty score display name for an Ageless platform.
 */
export const useSetBeautyScoreDisplayName = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setBeautyScoreDisplayName>>, TError,SetBeautyScoreDisplayNameMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setBeautyScoreDisplayName>>,
        TError,
        SetBeautyScoreDisplayNameMutationVariables,
        TContext
      > => {
      return useMutation(getSetBeautyScoreDisplayNameMutationOptions(options), queryClient);
    }
    /**
 * @summary Sets the allowed origins for a platform's Ageless website embed.
 */
export const setWebsiteEmbedAllowedOrigins = (
    platformId: string,
    setAllowedOriginsForAgelessWebsiteEmbedRequest: SetAllowedOriginsForAgelessWebsiteEmbedRequest,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/ageless/platforms/features/${platformId}/website-embed/allowed-origins`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setAllowedOriginsForAgelessWebsiteEmbedRequest, signal
    },
      );
    }




export const getSetWebsiteEmbedAllowedOriginsMutationKey = () => ['setWebsiteEmbedAllowedOrigins'] as const;

export const getSetWebsiteEmbedAllowedOriginsMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setWebsiteEmbedAllowedOrigins>>, TError,SetWebsiteEmbedAllowedOriginsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setWebsiteEmbedAllowedOrigins>>, TError,SetWebsiteEmbedAllowedOriginsMutationVariables, TContext> => {

const mutationKey = getSetWebsiteEmbedAllowedOriginsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setWebsiteEmbedAllowedOrigins>>, SetWebsiteEmbedAllowedOriginsMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  setWebsiteEmbedAllowedOrigins(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetWebsiteEmbedAllowedOriginsMutationResult = NonNullable<Awaited<ReturnType<typeof setWebsiteEmbedAllowedOrigins>>>
    export type SetWebsiteEmbedAllowedOriginsMutationBody = SetAllowedOriginsForAgelessWebsiteEmbedRequest
    export type SetWebsiteEmbedAllowedOriginsMutationError = ErrorType<ProblemDetails>
    export type SetWebsiteEmbedAllowedOriginsMutationVariables = {platformId: string;data: SetAllowedOriginsForAgelessWebsiteEmbedRequest}

    /**
 * @summary Sets the allowed origins for a platform's Ageless website embed.
 */
export const useSetWebsiteEmbedAllowedOrigins = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setWebsiteEmbedAllowedOrigins>>, TError,SetWebsiteEmbedAllowedOriginsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setWebsiteEmbedAllowedOrigins>>,
        TError,
        SetWebsiteEmbedAllowedOriginsMutationVariables,
        TContext
      > => {
      return useMutation(getSetWebsiteEmbedAllowedOriginsMutationOptions(options), queryClient);
    }
    /**
 * @summary Enables the Ageless website embed for a platform.
 */
export const enableWebsiteEmbed = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/ageless/platforms/features/${platformId}/website-embed/enable`, method: 'PUT', signal
    },
      );
    }




export const getEnableWebsiteEmbedMutationKey = () => ['enableWebsiteEmbed'] as const;

export const getEnableWebsiteEmbedMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableWebsiteEmbed>>, TError,EnableWebsiteEmbedMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof enableWebsiteEmbed>>, TError,EnableWebsiteEmbedMutationVariables, TContext> => {

const mutationKey = getEnableWebsiteEmbedMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enableWebsiteEmbed>>, EnableWebsiteEmbedMutationVariables> = (props) => {
          const {platformId} = props ?? {};

          return  enableWebsiteEmbed(platformId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnableWebsiteEmbedMutationResult = NonNullable<Awaited<ReturnType<typeof enableWebsiteEmbed>>>

    export type EnableWebsiteEmbedMutationError = ErrorType<ProblemDetails>
    export type EnableWebsiteEmbedMutationVariables = {platformId: string}

    /**
 * @summary Enables the Ageless website embed for a platform.
 */
export const useEnableWebsiteEmbed = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableWebsiteEmbed>>, TError,EnableWebsiteEmbedMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof enableWebsiteEmbed>>,
        TError,
        EnableWebsiteEmbedMutationVariables,
        TContext
      > => {
      return useMutation(getEnableWebsiteEmbedMutationOptions(options), queryClient);
    }
    /**
 * @summary Disables the Ageless website embed for a platform.
 */
export const disableWebsiteEmbed = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/ageless/platforms/features/${platformId}/website-embed/disable`, method: 'PUT', signal
    },
      );
    }




export const getDisableWebsiteEmbedMutationKey = () => ['disableWebsiteEmbed'] as const;

export const getDisableWebsiteEmbedMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableWebsiteEmbed>>, TError,DisableWebsiteEmbedMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof disableWebsiteEmbed>>, TError,DisableWebsiteEmbedMutationVariables, TContext> => {

const mutationKey = getDisableWebsiteEmbedMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableWebsiteEmbed>>, DisableWebsiteEmbedMutationVariables> = (props) => {
          const {platformId} = props ?? {};

          return  disableWebsiteEmbed(platformId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisableWebsiteEmbedMutationResult = NonNullable<Awaited<ReturnType<typeof disableWebsiteEmbed>>>

    export type DisableWebsiteEmbedMutationError = ErrorType<ProblemDetails>
    export type DisableWebsiteEmbedMutationVariables = {platformId: string}

    /**
 * @summary Disables the Ageless website embed for a platform.
 */
export const useDisableWebsiteEmbed = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableWebsiteEmbed>>, TError,DisableWebsiteEmbedMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disableWebsiteEmbed>>,
        TError,
        DisableWebsiteEmbedMutationVariables,
        TContext
      > => {
      return useMutation(getDisableWebsiteEmbedMutationOptions(options), queryClient);
    }
    /**
 * @summary Enables AI auto-reply for a platform.
 */
export const enableAiAutoReply = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/ageless/platforms/features/${platformId}/ai-auto-reply/enable`, method: 'PUT', signal
    },
      );
    }




export const getEnableAiAutoReplyMutationKey = () => ['enableAiAutoReply'] as const;

export const getEnableAiAutoReplyMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableAiAutoReply>>, TError,EnableAiAutoReplyMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof enableAiAutoReply>>, TError,EnableAiAutoReplyMutationVariables, TContext> => {

const mutationKey = getEnableAiAutoReplyMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enableAiAutoReply>>, EnableAiAutoReplyMutationVariables> = (props) => {
          const {platformId} = props ?? {};

          return  enableAiAutoReply(platformId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnableAiAutoReplyMutationResult = NonNullable<Awaited<ReturnType<typeof enableAiAutoReply>>>

    export type EnableAiAutoReplyMutationError = ErrorType<ProblemDetails>
    export type EnableAiAutoReplyMutationVariables = {platformId: string}

    /**
 * @summary Enables AI auto-reply for a platform.
 */
export const useEnableAiAutoReply = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableAiAutoReply>>, TError,EnableAiAutoReplyMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof enableAiAutoReply>>,
        TError,
        EnableAiAutoReplyMutationVariables,
        TContext
      > => {
      return useMutation(getEnableAiAutoReplyMutationOptions(options), queryClient);
    }
    /**
 * @summary Disables AI auto-reply for a platform.
 */
export const disableAiAutoReply = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/ageless/platforms/features/${platformId}/ai-auto-reply/disable`, method: 'PUT', signal
    },
      );
    }




export const getDisableAiAutoReplyMutationKey = () => ['disableAiAutoReply'] as const;

export const getDisableAiAutoReplyMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableAiAutoReply>>, TError,DisableAiAutoReplyMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof disableAiAutoReply>>, TError,DisableAiAutoReplyMutationVariables, TContext> => {

const mutationKey = getDisableAiAutoReplyMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableAiAutoReply>>, DisableAiAutoReplyMutationVariables> = (props) => {
          const {platformId} = props ?? {};

          return  disableAiAutoReply(platformId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisableAiAutoReplyMutationResult = NonNullable<Awaited<ReturnType<typeof disableAiAutoReply>>>

    export type DisableAiAutoReplyMutationError = ErrorType<ProblemDetails>
    export type DisableAiAutoReplyMutationVariables = {platformId: string}

    /**
 * @summary Disables AI auto-reply for a platform.
 */
export const useDisableAiAutoReply = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableAiAutoReply>>, TError,DisableAiAutoReplyMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disableAiAutoReply>>,
        TError,
        DisableAiAutoReplyMutationVariables,
        TContext
      > => {
      return useMutation(getDisableAiAutoReplyMutationOptions(options), queryClient);
    }
    /**
 * @summary Retrieve whether AI auto-reply is enabled for a platform. Opt-in: an unconfigured platform
returns `Enabled = false` (not 404), so the settings tab renders the toggle off by default.
 */
export const getAiAutoReplySettings = (
    platformId: string,
    params?: GetAiAutoReplySettingsParams,
 signal?: AbortSignal
) => {


      return customAxios<DisplayAiAutoReplySettingsResponse>(
      {url: `/api/v1/ageless/platforms/features/${platformId}/ai-auto-reply`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetAiAutoReplySettingsQueryKey = (platformId: string,
    params?: GetAiAutoReplySettingsParams,) => {
    return [
    `/api/v1/ageless/platforms/features/${platformId}/ai-auto-reply`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAiAutoReplySettingsQueryOptions = <TData = Awaited<ReturnType<typeof getAiAutoReplySettings>>, TError = ErrorType<ProblemDetails>>(platformId: string,
    params?: GetAiAutoReplySettingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiAutoReplySettings>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAiAutoReplySettingsQueryKey(platformId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiAutoReplySettings>>> = ({ signal }) => getAiAutoReplySettings(platformId,params, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAiAutoReplySettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAiAutoReplySettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getAiAutoReplySettings>>>
export type GetAiAutoReplySettingsQueryError = ErrorType<ProblemDetails>


export function useGetAiAutoReplySettings<TData = Awaited<ReturnType<typeof getAiAutoReplySettings>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params: undefined |  GetAiAutoReplySettingsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiAutoReplySettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiAutoReplySettings>>,
          TError,
          Awaited<ReturnType<typeof getAiAutoReplySettings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAiAutoReplySettings<TData = Awaited<ReturnType<typeof getAiAutoReplySettings>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params?: GetAiAutoReplySettingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiAutoReplySettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiAutoReplySettings>>,
          TError,
          Awaited<ReturnType<typeof getAiAutoReplySettings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAiAutoReplySettings<TData = Awaited<ReturnType<typeof getAiAutoReplySettings>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params?: GetAiAutoReplySettingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiAutoReplySettings>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve whether AI auto-reply is enabled for a platform. Opt-in: an unconfigured platform
returns `Enabled = false` (not 404), so the settings tab renders the toggle off by default.
 */

export function useGetAiAutoReplySettings<TData = Awaited<ReturnType<typeof getAiAutoReplySettings>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params?: GetAiAutoReplySettingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiAutoReplySettings>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAiAutoReplySettingsQueryOptions(platformId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetAiAutoReplySettingsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAiAutoReplySettings>>, TError = ErrorType<ProblemDetails>>(platformId: string,
    params?: GetAiAutoReplySettingsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAiAutoReplySettings>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAiAutoReplySettingsQueryKey(platformId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiAutoReplySettings>>> = ({ signal }) => getAiAutoReplySettings(platformId,params, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAiAutoReplySettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetAiAutoReplySettingsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAiAutoReplySettings>>>
export type GetAiAutoReplySettingsSuspenseQueryError = ErrorType<ProblemDetails>


export function useGetAiAutoReplySettingsSuspense<TData = Awaited<ReturnType<typeof getAiAutoReplySettings>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params: undefined |  GetAiAutoReplySettingsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAiAutoReplySettings>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAiAutoReplySettingsSuspense<TData = Awaited<ReturnType<typeof getAiAutoReplySettings>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params?: GetAiAutoReplySettingsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAiAutoReplySettings>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAiAutoReplySettingsSuspense<TData = Awaited<ReturnType<typeof getAiAutoReplySettings>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params?: GetAiAutoReplySettingsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAiAutoReplySettings>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve whether AI auto-reply is enabled for a platform. Opt-in: an unconfigured platform
returns `Enabled = false` (not 404), so the settings tab renders the toggle off by default.
 */

export function useGetAiAutoReplySettingsSuspense<TData = Awaited<ReturnType<typeof getAiAutoReplySettings>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params?: GetAiAutoReplySettingsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAiAutoReplySettings>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAiAutoReplySettingsSuspenseQueryOptions(platformId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Send Ageless website embed setup instructions email to a recipient on
behalf of the requesting admin user. The frontend supplies subject + a
base64-encoded body (base64 keeps the embed snippet's script/inline
handlers opaque so the upstream WAF does not flag the request as XSS and
drop it); the backend decodes the body, prepends a server-controlled
prelude, and sends via the canonical email pipeline with Reply-To set to
the admin's email and the admin BCC'd a copy of the outbound message.
 */
export const sendWebsiteEmbedInstructions = (
    platformId: string,
    sendAgelessWebsiteEmbedInstructionsRequest: SendAgelessWebsiteEmbedInstructionsRequest,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/ageless/platforms/features/${platformId}/website-embed/send-instructions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendAgelessWebsiteEmbedInstructionsRequest, signal
    },
      );
    }




export const getSendWebsiteEmbedInstructionsMutationKey = () => ['sendWebsiteEmbedInstructions'] as const;

export const getSendWebsiteEmbedInstructionsMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendWebsiteEmbedInstructions>>, TError,SendWebsiteEmbedInstructionsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendWebsiteEmbedInstructions>>, TError,SendWebsiteEmbedInstructionsMutationVariables, TContext> => {

const mutationKey = getSendWebsiteEmbedInstructionsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendWebsiteEmbedInstructions>>, SendWebsiteEmbedInstructionsMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  sendWebsiteEmbedInstructions(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendWebsiteEmbedInstructionsMutationResult = NonNullable<Awaited<ReturnType<typeof sendWebsiteEmbedInstructions>>>
    export type SendWebsiteEmbedInstructionsMutationBody = SendAgelessWebsiteEmbedInstructionsRequest
    export type SendWebsiteEmbedInstructionsMutationError = ErrorType<ProblemDetails>
    export type SendWebsiteEmbedInstructionsMutationVariables = {platformId: string;data: SendAgelessWebsiteEmbedInstructionsRequest}

    /**
 * @summary Send Ageless website embed setup instructions email to a recipient on
behalf of the requesting admin user. The frontend supplies subject + a
base64-encoded body (base64 keeps the embed snippet's script/inline
handlers opaque so the upstream WAF does not flag the request as XSS and
drop it); the backend decodes the body, prepends a server-controlled
prelude, and sends via the canonical email pipeline with Reply-To set to
the admin's email and the admin BCC'd a copy of the outbound message.
 */
export const useSendWebsiteEmbedInstructions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendWebsiteEmbedInstructions>>, TError,SendWebsiteEmbedInstructionsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendWebsiteEmbedInstructions>>,
        TError,
        SendWebsiteEmbedInstructionsMutationVariables,
        TContext
      > => {
      return useMutation(getSendWebsiteEmbedInstructionsMutationOptions(options), queryClient);
    }
    /**
 * @summary Mints the signed token behind a shareable Ageless Marketing setup link. The link lets a
practice's web developer open the marketing page without a login and set the website-embed
allowlist — and nothing else. It grants no capability the requesting admin does not
already have on this platform, and expires (90 days by default) so a forwarded link
stops working.
 */
export const generateMarketingSetupLink = (
    platformId: string,
    generateAgelessMarketingSetupTokenRequest: GenerateAgelessMarketingSetupTokenRequest,
 signal?: AbortSignal
) => {


      return customAxios<DisplayGeneratedAgelessMarketingSetupTokenResponse>(
      {url: `/api/v1/ageless/platforms/features/${platformId}/marketing/setup-link`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: generateAgelessMarketingSetupTokenRequest, signal
    },
      );
    }




export const getGenerateMarketingSetupLinkMutationKey = () => ['generateMarketingSetupLink'] as const;

export const getGenerateMarketingSetupLinkMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateMarketingSetupLink>>, TError,GenerateMarketingSetupLinkMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof generateMarketingSetupLink>>, TError,GenerateMarketingSetupLinkMutationVariables, TContext> => {

const mutationKey = getGenerateMarketingSetupLinkMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateMarketingSetupLink>>, GenerateMarketingSetupLinkMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  generateMarketingSetupLink(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateMarketingSetupLinkMutationResult = NonNullable<Awaited<ReturnType<typeof generateMarketingSetupLink>>>
    export type GenerateMarketingSetupLinkMutationBody = GenerateAgelessMarketingSetupTokenRequest
    export type GenerateMarketingSetupLinkMutationError = ErrorType<ProblemDetails>
    export type GenerateMarketingSetupLinkMutationVariables = {platformId: string;data: GenerateAgelessMarketingSetupTokenRequest}

    /**
 * @summary Mints the signed token behind a shareable Ageless Marketing setup link. The link lets a
practice's web developer open the marketing page without a login and set the website-embed
allowlist — and nothing else. It grants no capability the requesting admin does not
already have on this platform, and expires (90 days by default) so a forwarded link
stops working.
 */
export const useGenerateMarketingSetupLink = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateMarketingSetupLink>>, TError,GenerateMarketingSetupLinkMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateMarketingSetupLink>>,
        TError,
        GenerateMarketingSetupLinkMutationVariables,
        TContext
      > => {
      return useMutation(getGenerateMarketingSetupLinkMutationOptions(options), queryClient);
    }
    /**
 * @summary Retrieve Ageless website embed settings for a platform.
 */
export const getWebsiteEmbedSettings = (
    platformId: string,
    params?: GetWebsiteEmbedSettingsParams,
 signal?: AbortSignal
) => {


      return customAxios<DisplayAgelessWebsiteEmbedSettingsResponse>(
      {url: `/api/v1/ageless/platforms/features/${platformId}/website-embed-settings`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetWebsiteEmbedSettingsQueryKey = (platformId: string,
    params?: GetWebsiteEmbedSettingsParams,) => {
    return [
    `/api/v1/ageless/platforms/features/${platformId}/website-embed-settings`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetWebsiteEmbedSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getWebsiteEmbedSettings>>, TError = ErrorType<ProblemDetails>>(platformId: string,
    params?: GetWebsiteEmbedSettingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebsiteEmbedSettings>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWebsiteEmbedSettingsQueryKey(platformId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWebsiteEmbedSettings>>> = ({ signal }) => getWebsiteEmbedSettings(platformId,params, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWebsiteEmbedSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWebsiteEmbedSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getWebsiteEmbedSettings>>>
export type GetWebsiteEmbedSettingsQueryError = ErrorType<ProblemDetails>


export function useGetWebsiteEmbedSettings<TData = Awaited<ReturnType<typeof getWebsiteEmbedSettings>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params: undefined |  GetWebsiteEmbedSettingsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebsiteEmbedSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWebsiteEmbedSettings>>,
          TError,
          Awaited<ReturnType<typeof getWebsiteEmbedSettings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWebsiteEmbedSettings<TData = Awaited<ReturnType<typeof getWebsiteEmbedSettings>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params?: GetWebsiteEmbedSettingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebsiteEmbedSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWebsiteEmbedSettings>>,
          TError,
          Awaited<ReturnType<typeof getWebsiteEmbedSettings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWebsiteEmbedSettings<TData = Awaited<ReturnType<typeof getWebsiteEmbedSettings>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params?: GetWebsiteEmbedSettingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebsiteEmbedSettings>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve Ageless website embed settings for a platform.
 */

export function useGetWebsiteEmbedSettings<TData = Awaited<ReturnType<typeof getWebsiteEmbedSettings>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params?: GetWebsiteEmbedSettingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebsiteEmbedSettings>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWebsiteEmbedSettingsQueryOptions(platformId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetWebsiteEmbedSettingsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getWebsiteEmbedSettings>>, TError = ErrorType<ProblemDetails>>(platformId: string,
    params?: GetWebsiteEmbedSettingsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWebsiteEmbedSettings>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWebsiteEmbedSettingsQueryKey(platformId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWebsiteEmbedSettings>>> = ({ signal }) => getWebsiteEmbedSettings(platformId,params, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWebsiteEmbedSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetWebsiteEmbedSettingsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getWebsiteEmbedSettings>>>
export type GetWebsiteEmbedSettingsSuspenseQueryError = ErrorType<ProblemDetails>


export function useGetWebsiteEmbedSettingsSuspense<TData = Awaited<ReturnType<typeof getWebsiteEmbedSettings>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params: undefined |  GetWebsiteEmbedSettingsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWebsiteEmbedSettings>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWebsiteEmbedSettingsSuspense<TData = Awaited<ReturnType<typeof getWebsiteEmbedSettings>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params?: GetWebsiteEmbedSettingsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWebsiteEmbedSettings>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWebsiteEmbedSettingsSuspense<TData = Awaited<ReturnType<typeof getWebsiteEmbedSettings>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params?: GetWebsiteEmbedSettingsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWebsiteEmbedSettings>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve Ageless website embed settings for a platform.
 */

export function useGetWebsiteEmbedSettingsSuspense<TData = Awaited<ReturnType<typeof getWebsiteEmbedSettings>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params?: GetWebsiteEmbedSettingsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWebsiteEmbedSettings>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWebsiteEmbedSettingsSuspenseQueryOptions(platformId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Generates a short-lived embed token authorizing an allowlisted parent origin to embed the Ageless website widget for the specified platform.
 */
export const generateWebsiteEmbedToken = (
    platformId: string,
    generateAgelessWebsiteEmbedTokenRequest: GenerateAgelessWebsiteEmbedTokenRequest,
 signal?: AbortSignal
) => {


      return customAxios<DisplayGeneratedAgelessWebsiteEmbedTokenResponse>(
      {url: `/api/v1/ageless/short-lived/platforms/${platformId}/website-embed-token`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: generateAgelessWebsiteEmbedTokenRequest, signal
    },
      );
    }




export const getGenerateWebsiteEmbedTokenMutationKey = () => ['generateWebsiteEmbedToken'] as const;

export const getGenerateWebsiteEmbedTokenMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateWebsiteEmbedToken>>, TError,GenerateWebsiteEmbedTokenMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof generateWebsiteEmbedToken>>, TError,GenerateWebsiteEmbedTokenMutationVariables, TContext> => {

const mutationKey = getGenerateWebsiteEmbedTokenMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateWebsiteEmbedToken>>, GenerateWebsiteEmbedTokenMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  generateWebsiteEmbedToken(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateWebsiteEmbedTokenMutationResult = NonNullable<Awaited<ReturnType<typeof generateWebsiteEmbedToken>>>
    export type GenerateWebsiteEmbedTokenMutationBody = GenerateAgelessWebsiteEmbedTokenRequest
    export type GenerateWebsiteEmbedTokenMutationError = ErrorType<ProblemDetails>
    export type GenerateWebsiteEmbedTokenMutationVariables = {platformId: string;data: GenerateAgelessWebsiteEmbedTokenRequest}

    /**
 * @summary Generates a short-lived embed token authorizing an allowlisted parent origin to embed the Ageless website widget for the specified platform.
 */
export const useGenerateWebsiteEmbedToken = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateWebsiteEmbedToken>>, TError,GenerateWebsiteEmbedTokenMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateWebsiteEmbedToken>>,
        TError,
        GenerateWebsiteEmbedTokenMutationVariables,
        TContext
      > => {
      return useMutation(getGenerateWebsiteEmbedTokenMutationOptions(options), queryClient);
    }
    /**
 * @summary Validates a previously issued Ageless website embed token and returns its associated platform details.
 */
export const validateWebsiteEmbedToken = (
    params?: ValidateWebsiteEmbedTokenParams,
    headers?: ValidateWebsiteEmbedTokenHeaders,
 signal?: AbortSignal
) => {


      return customAxios<DisplayValidatedAgelessWebsiteEmbedTokenResponse>(
      {url: `/api/v1/ageless/short-lived/platforms/website-embed-token/validate`, method: 'GET',
      headers,
        params, signal
    },
      );
    }




export const getValidateWebsiteEmbedTokenQueryKey = (params?: ValidateWebsiteEmbedTokenParams,) => {
    return [
    `/api/v1/ageless/short-lived/platforms/website-embed-token/validate`, ...(params ? [params] : [])
    ] as const;
    }


export const getValidateWebsiteEmbedTokenQueryOptions = <TData = Awaited<ReturnType<typeof validateWebsiteEmbedToken>>, TError = ErrorType<ProblemDetails>>(params?: ValidateWebsiteEmbedTokenParams,
    headers?: ValidateWebsiteEmbedTokenHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof validateWebsiteEmbedToken>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getValidateWebsiteEmbedTokenQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof validateWebsiteEmbedToken>>> = ({ signal }) => validateWebsiteEmbedToken(params,headers, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof validateWebsiteEmbedToken>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ValidateWebsiteEmbedTokenQueryResult = NonNullable<Awaited<ReturnType<typeof validateWebsiteEmbedToken>>>
export type ValidateWebsiteEmbedTokenQueryError = ErrorType<ProblemDetails>


export function useValidateWebsiteEmbedToken<TData = Awaited<ReturnType<typeof validateWebsiteEmbedToken>>, TError = ErrorType<ProblemDetails>>(
 params: undefined |  ValidateWebsiteEmbedTokenParams,
    headers: undefined |  ValidateWebsiteEmbedTokenHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof validateWebsiteEmbedToken>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof validateWebsiteEmbedToken>>,
          TError,
          Awaited<ReturnType<typeof validateWebsiteEmbedToken>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useValidateWebsiteEmbedToken<TData = Awaited<ReturnType<typeof validateWebsiteEmbedToken>>, TError = ErrorType<ProblemDetails>>(
 params?: ValidateWebsiteEmbedTokenParams,
    headers?: ValidateWebsiteEmbedTokenHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof validateWebsiteEmbedToken>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof validateWebsiteEmbedToken>>,
          TError,
          Awaited<ReturnType<typeof validateWebsiteEmbedToken>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useValidateWebsiteEmbedToken<TData = Awaited<ReturnType<typeof validateWebsiteEmbedToken>>, TError = ErrorType<ProblemDetails>>(
 params?: ValidateWebsiteEmbedTokenParams,
    headers?: ValidateWebsiteEmbedTokenHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof validateWebsiteEmbedToken>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Validates a previously issued Ageless website embed token and returns its associated platform details.
 */

export function useValidateWebsiteEmbedToken<TData = Awaited<ReturnType<typeof validateWebsiteEmbedToken>>, TError = ErrorType<ProblemDetails>>(
 params?: ValidateWebsiteEmbedTokenParams,
    headers?: ValidateWebsiteEmbedTokenHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof validateWebsiteEmbedToken>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getValidateWebsiteEmbedTokenQueryOptions(params,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getValidateWebsiteEmbedTokenSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof validateWebsiteEmbedToken>>, TError = ErrorType<ProblemDetails>>(params?: ValidateWebsiteEmbedTokenParams,
    headers?: ValidateWebsiteEmbedTokenHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof validateWebsiteEmbedToken>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getValidateWebsiteEmbedTokenQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof validateWebsiteEmbedToken>>> = ({ signal }) => validateWebsiteEmbedToken(params,headers, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof validateWebsiteEmbedToken>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type ValidateWebsiteEmbedTokenSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof validateWebsiteEmbedToken>>>
export type ValidateWebsiteEmbedTokenSuspenseQueryError = ErrorType<ProblemDetails>


export function useValidateWebsiteEmbedTokenSuspense<TData = Awaited<ReturnType<typeof validateWebsiteEmbedToken>>, TError = ErrorType<ProblemDetails>>(
 params: undefined |  ValidateWebsiteEmbedTokenParams,
    headers: undefined |  ValidateWebsiteEmbedTokenHeaders, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof validateWebsiteEmbedToken>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useValidateWebsiteEmbedTokenSuspense<TData = Awaited<ReturnType<typeof validateWebsiteEmbedToken>>, TError = ErrorType<ProblemDetails>>(
 params?: ValidateWebsiteEmbedTokenParams,
    headers?: ValidateWebsiteEmbedTokenHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof validateWebsiteEmbedToken>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useValidateWebsiteEmbedTokenSuspense<TData = Awaited<ReturnType<typeof validateWebsiteEmbedToken>>, TError = ErrorType<ProblemDetails>>(
 params?: ValidateWebsiteEmbedTokenParams,
    headers?: ValidateWebsiteEmbedTokenHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof validateWebsiteEmbedToken>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Validates a previously issued Ageless website embed token and returns its associated platform details.
 */

export function useValidateWebsiteEmbedTokenSuspense<TData = Awaited<ReturnType<typeof validateWebsiteEmbedToken>>, TError = ErrorType<ProblemDetails>>(
 params?: ValidateWebsiteEmbedTokenParams,
    headers?: ValidateWebsiteEmbedTokenHeaders, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof validateWebsiteEmbedToken>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getValidateWebsiteEmbedTokenSuspenseQueryOptions(params,headers,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Retrieves the generic Ageless host configuration including the admin app base URL.
 */
export const getAgelessHostConfiguration = (

 signal?: AbortSignal
) => {


      return customAxios<DisplayAgelessHostConfiguration>(
      {url: `/api/v1/ageless/host-configuration`, method: 'GET', signal
    },
      );
    }




export const getGetAgelessHostConfigurationQueryKey = () => {
    return [
    `/api/v1/ageless/host-configuration`
    ] as const;
    }


export const getGetAgelessHostConfigurationQueryOptions = <TData = Awaited<ReturnType<typeof getAgelessHostConfiguration>>, TError = ErrorType<ProblemDetails>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgelessHostConfiguration>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAgelessHostConfigurationQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgelessHostConfiguration>>> = ({ signal }) => getAgelessHostConfiguration(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAgelessHostConfiguration>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAgelessHostConfigurationQueryResult = NonNullable<Awaited<ReturnType<typeof getAgelessHostConfiguration>>>
export type GetAgelessHostConfigurationQueryError = ErrorType<ProblemDetails>


export function useGetAgelessHostConfiguration<TData = Awaited<ReturnType<typeof getAgelessHostConfiguration>>, TError = ErrorType<ProblemDetails>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgelessHostConfiguration>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgelessHostConfiguration>>,
          TError,
          Awaited<ReturnType<typeof getAgelessHostConfiguration>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAgelessHostConfiguration<TData = Awaited<ReturnType<typeof getAgelessHostConfiguration>>, TError = ErrorType<ProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgelessHostConfiguration>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgelessHostConfiguration>>,
          TError,
          Awaited<ReturnType<typeof getAgelessHostConfiguration>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAgelessHostConfiguration<TData = Awaited<ReturnType<typeof getAgelessHostConfiguration>>, TError = ErrorType<ProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgelessHostConfiguration>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the generic Ageless host configuration including the admin app base URL.
 */

export function useGetAgelessHostConfiguration<TData = Awaited<ReturnType<typeof getAgelessHostConfiguration>>, TError = ErrorType<ProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgelessHostConfiguration>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAgelessHostConfigurationQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetAgelessHostConfigurationSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAgelessHostConfiguration>>, TError = ErrorType<ProblemDetails>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAgelessHostConfiguration>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAgelessHostConfigurationQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgelessHostConfiguration>>> = ({ signal }) => getAgelessHostConfiguration(signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAgelessHostConfiguration>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetAgelessHostConfigurationSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAgelessHostConfiguration>>>
export type GetAgelessHostConfigurationSuspenseQueryError = ErrorType<ProblemDetails>


export function useGetAgelessHostConfigurationSuspense<TData = Awaited<ReturnType<typeof getAgelessHostConfiguration>>, TError = ErrorType<ProblemDetails>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAgelessHostConfiguration>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAgelessHostConfigurationSuspense<TData = Awaited<ReturnType<typeof getAgelessHostConfiguration>>, TError = ErrorType<ProblemDetails>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAgelessHostConfiguration>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAgelessHostConfigurationSuspense<TData = Awaited<ReturnType<typeof getAgelessHostConfiguration>>, TError = ErrorType<ProblemDetails>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAgelessHostConfiguration>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the generic Ageless host configuration including the admin app base URL.
 */

export function useGetAgelessHostConfigurationSuspense<TData = Awaited<ReturnType<typeof getAgelessHostConfiguration>>, TError = ErrorType<ProblemDetails>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAgelessHostConfiguration>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAgelessHostConfigurationSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






